module.exports = __webpack_public_path__ + "static/media/btn-readmore-white.9d7dd1cd.svg";